
    import { defineComponent } from 'vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'TitlesAndPromotions',
        props: {
            titleAndPromotionDetails: {
                type: Object as () => TitleAndPromotionsDetails,
                required: true,
            }
        },
        data() {
            return {
                dataDiscount: {
                    discountRate: null,
                    containDiscountRange: false,
                    changeTitlePromotions: false,
                },
            }
        },
        methods: {
            setDiscountData(data) {
                this.dataDiscount = { ...data };
            },
        },
    });
